

const messages = {
  en: {
    sidebar: {
      assetsView: "Assets",
      accountsView: "People",
      monitorView: "Monitor",
      applicationsView: "Admin Panel"
    },
    common: {
      cancelBtn: "Cancel",
      sendBtn: "Send",
      unknown: "Unknown",
      save: "Save",
      new: "New",
      close: "Close",
      backBtn:'Back',
      nextBtn: 'Next',
      yes: 'Yes',
      no: 'No'
    },
    control_panel:{
      title: "Control Panel"
    },
    monitor:{
      title: "Monitor",
      noTelemetry: "No telemetry data available for this device.",
      tabs:{
        activityTab: "Activity",
        performanceTab:  "Performance",
        logsTab: "Audit Logs",
        eventTab: "System Events"
      }
    },
    application:{
      title: "Application",
      tabs:{
        appliactionTab: "Applications",
        runnersTab: "Runners"
      }
    },
    profiles: {
      title: 'Profiles',
      tabs: {
        adminTab: "Administrators",
        operatorsTab: "Operators",
        operatorsGroupTab: "Operator Group"
      },
      operatorCredentials: {
        usernameLabel: 'Username',
        passwordLabel: 'Password',
        hints: {
          minLength: 'Min. length 8 characters',
          includeNumber: 'Must include at least one number',
          includeUppercase: 'Must include at least one uppercase letter',
          includeSpecial: 'Must include at least one special character',
        },
        rules: {
          required: 'Required',
          minLength: 'Min length 5',
          includeNumber: 'Must include a number',
          includeLowercase: 'Must include a lowercase letter',
          includeUppercase: 'Must include an uppercase letter',
          includeSpecial: 'Must include a special character',
          noBlankSpaces: 'No blank spaces allowed',
        },
      },
      operatorView: {
        loadError: {
          title: 'Failed to load operator',
          retryBtn: 'Try Again',
        },
        loading: 'Loading...',
        loadingOperator: 'Loading Operator...',
        operatorFallback: 'Operator',
        operatorDetailsFallback: 'Operator Details',
        online: 'Online',
        offline: 'Offline',
        sections: {
          mainInfo: 'Main info',
          additionalDetails: 'Additional details',
          customFields: 'Custom fields',
        },
        fields: {
          firstName: 'First name',
          dateOfBirth: 'Date of birth',
          email: 'E-mail',
          lastName: 'Last name',
          gender: 'Gender',
          phoneNumber: 'Phone number',
          username: 'Username',
          status: 'Status',
          visionId: 'Vision ID',
          tags: 'Tags',
          operatorGroups: 'Operator Groups',
          registeredAt: 'Registered At',
          lastSeen: 'Last Seen',
          uuid: 'UUID',
          locations: 'Locations',
          externalId: 'External ID',
          permissions: 'Permissions',
          limits: 'Limits',
          registeredBy: 'Registered By',
          lastSeenAt: 'Last Seen At',
          id: 'ID',
        },
        values: {
          enabled: 'Enabled',
          disabled: 'Disabled',
          allPermissions: 'All permissions',
          noLimits: 'No limits',
        },
      },
    },
    assets: {
      title: "Assets",
      tabs: {
        locationsTab: "Locations",
        devicesTab: "Devices",
        groupsTab: "Location Groups",
        working_time: "Working Time",
        custom_fields: "Custom Fields",
        operatorsTab: "Operators"
      },
      display: {
        resolutionLabel: "Resolution",
        refreshRateLabel: "Refresh rate",
        orientationLabel: "Orientation",
        displayedAppsLabel: "Displayed Apps",
        searchPlaceholder: "Search",
        primaryDisplayLabel: "Primary Display",
        disableDisplayLabel: "Disable Display",
        streamDisplayLabel: "Stream Display (LAN)",
        configureAppLabel: "Configure App"
      },
      devices: {
        emptyDevicesTitle: "It appears there are no added Devices",
        emptyDevicesDescription: "To add one, hover the Plus button at the bottom right of your screen and choose appropriate option.",
        emptySearchTitle: "No results found",
        emptySearchDescription: "Try a different search query",
        searchPlaceholder: "Search",
        fab: {
          addRunner: "Add Runner Device",
          addManually: "Add Device Manually",
          detect: "Detect Devices"
        },
        addRunner: {
          title: "Add Runner Device",
          description: "Once added, you will be able to connect and manage this device.",
          addNew: "Add New",
          deviceNameLabel: "Device Name",
          deviceNamePlaceholder: "Friendly name for your device",
          deviceDescriptionLabel: "Description",
          deviceLocationLabel: "Location",
          deviceLocationPlaceholder: "Allocate device to Location",
          addBtn: "Add"
        },
        deviceInfo: {
          
          tabs: {
            general: "General",
            peripherals: "Peripherals",
            assetInfo: "Asset Info",
            settings: "Settings",
            devices: "Devices",
            logs: "Logs",
            reports: "Reports",
            working_time: "Working time"
          },
          installationCode: {
            codeMessage: "New device has been added. Use the following code to connect it with the physical device within the code validity period.",
            codeMessageReconnect: "Device is ready for reconnection. Use the following code to connect it with the physical device within the code validity period.",
            codeExpiredMessage: "Code has expired. If you still wish to connect to this device, generate new code by clicking \"Reset Code\" button, otherwise you may delete it to keep things tidy.",
            codeResetMessage: "Code has been reset. Old code won't work anymore. Use the following code to connect it with the physical device within the code validity period.",
            codeEmailSentMessage: "Email with code sent to ",
            codeEmailSentInfo: "Once the recipient establishes connection with added device, you will be able to manage it. If you need to, you can always make sent code invalid by resetting it.",
            expiresIn: "Code expires ",
            expired: "Code expired ",
            resetCodeBtn: "Reset Code",
            codeInfoWhenUsed: "Once the code is successfully used, added device will become connected. In the meantime, you can always reset code if you need to.",
            codeInfoSendEmail: "You can also send this code to desired email address. Recipient will receive code, custom message and default instructions on how to use code to connect.",
            connectionPendingTitle: "Connection pending...",
            connectionPendingMessage: "Device is currently in the connection pending state. Once it is connected successfully, it will become configurable. This state is usually caused by unexpected internet problems during device connection initialization.",
            connectionPendingAction: "If you wish to stop the existing connection process and start again, simply click the \"Terminate Connection\" button down below.",
            terminateConnectionBtn: "Terminate Connection",
            archivedMessage: "The device has been consigned to the archives. To procure the installation code, the device must undergo an unarchiving process.",
            scanQrBtn: "Scan QR",
            scanQrTitle: "Scan your QR Code",
            scanQrDescription: "Point your camera to the QR Code displayed on Code Connect app",
            emailLabel: "Email",
            messageLabel: "Message",
            emailHint: "You don't need to write code here. It will automatically be sent"
          },
          info: {
            lastOnlineLabel: "Last Online",
            addedByLabel: "Added By",
            connectedOnLabel: "Connected On",

            operatingSystemLabel: "Operating System",
            osVersionLabel: "OS Version",
            osArchitectureLabel: "OS Architecture",

            motherboardLabel: "Motherboard",
            cpuLabel: "CPU",
            graphicCardLabel: "Graphics Card",

            ramLabel: "RAM",
            localIpLabel: "Local IP",
            externalIpLabel: "External IP",
            macLabel: "MAC Address",
            machineID: "Machine ID",
            installationDateLabel: "Installation Date",
            installationUuidLabel: "Installation UUID",
            installationNameLabel: "Installation Name",
            saltMinionIdLabel: "Salt Minion ID",
            lastUpdatedLabel: "Last Updated",
            nsDeskIdLabel: "NS Desk ID",
            deviceCategoryLabel: "Device Category",
            deviceTypeLabel: "Device Type",
            deviceClass: "Device Class",
            connectionStatusLabel: "Activity Status",
            deviceStatusLabel: "Device Status",
            onlineStreakLabel: "Online Streak",
            offlineStreakLabel: "Offline Streak",
            locationLabel: "Location",
            addedOnLabel: "Added On",
            uuidLabel: "UUID",
            actionsLabel: "Actions",
            connectionStatusOnline: "Online",
            connectionStatusOffline: "Offline",
            deviceStatusEnabled: "Enabled",
            deviceStatusDisabled: "Disabled",
            ipAddressLabel: "IP Address",
            debugModeTitle: "Debug Mode",
            visionEnableTitle: "Vision Workers",
            visionEnableOfflineTitle: "Vision Offline Mode (Time Attendence)"
          },
          settings: {
              reboot: {
                header: 'Remote Control',
                title: 'Reboot',
                description:
                  'Force device to restart. It is recommended this you reboot your device from time to time in order to keep it running smoothly.',
                button: 'Reboot',
              },
              shutdown: {
                title: 'Shut Down',
                description:
                  'Shut down device completely. Be careful, as you won’t be able to remotely turn it on again.',
                button: 'Shut Down',
              },
              rd: {
                title: 'Remote Desktop (RD)',
                description:
                  'Access and interact with the device just like you are in front of it, even if you are physically miles away.',
                button: 'Access RD',
              },
              screenshot: {
                title: 'Request Screenshot',
                description:
                  'Take screenshot and immediately see what is running on all displays. If you need them for later viewing, make sure to download them locally.',
                button: 'Take Screenshot',
              },
              confTool: {
                title: 'Run Configuration Tool',
                description:
                  'Spawn the hardware configuration tool on the physical device for on-site setup.',
                button: 'Run Conf Tool',
                confirm: {
                  title: 'Run Configuration Tool',
                  message: 'Are you sure you want to spawn Configuration tool on physical device?',
                  button: 'Run Configuration Tool',
                },
              },
              touchscreenCalibration: {
                title: 'Trigger Calibration',
                description:
                  'Start touchscreen calibration on the physical device.',
                button: 'Trigger Calibration',
                confirm: {
                  title: 'Trigger Calibration',
                  message: 'Are you sure you want to trigger touchscreen calibration on the physical device?',
                  button: 'Trigger Calibration',
                },
              },
                disable: {
                title: 'Disable',
                description:
                  "Disable device and prevent user interaction with it. Comes handy when you don't want anyone to interfere with the device and its apps.",
              },
              debug: {
                title: 'Enable Debug Mode',
                description:
                  'Debug mode enables device user to open devtools and troubleshoot possible issues locally on the device.',
              },
              replacement: {
                title: 'Generate Replacement Code',
                description:
                  'Generate replacement code for reconnecting this device, one just like you used for connecting it in the first place.',
                button: 'Generate',
              },
              vision: {
                header: 'Vision Settings', 
                workersPending: 'Vision workers is still pending. This might take some time. Please do not reboot or shutdown the device in the mean time.',
                offlineModePending: 'Vision offline is still pending. This might take some time. Please do not reboot or shutdown the device in the mean time.',
                visionWorkers:{
                  title: 'Enable Vision Workers',
                  description: 'Enable vision processing on this device for controling cameras.',
                },
                visionOffline: {
                   title: 'Enable Vision Offline Mode (Time Attendence)',
                  description: 'Enable offline mode for proccessing Time Attendence events even when internet connection is down. Offline events are  synced when internet connection is back on.',
                }
                
              },
              rssh:{
                header: 'Advanced Settings',
                title: 'Request RSSH',
                description: 'Request RSSH port for inspecting and configuring device via CLI tool of your choice. This option is only visible to Super Admins.',
                button: 'Request RSSH'
              },
              hvnc:{
                title: 'Headless VNC',
                description: 'Access device similar to Remote Desktop but with headless approach and virtual display functionality. This option is only visible to Developers.',
                button: 'Start Headless VNC'
              },
              notices: {
                vision: "Vision",
                visionPending:
                  'is still pending. This might take some time. Please do not reboot or shutdown the device in the mean time.',
              },
              labels: {
                enabled: 'Enabled',
                disabled: 'Disabled',
              },
            },
          sections: {
            description: "Description",
            tags: "Tags",
            comments: "Comments"
          },
          typeDescriptions: {
            PC: "Connected computer can be used for a variety of purposes, such as displaying apps in kiosk mode, or running background services and providing processing power for services demanding apps.",
            'Linux Computer': "Connected computer can be used for a variety of purposes, such as displaying apps in kiosk mode, or running background services and providing processing power for services demanding apps.",
            'RaspberryPi': "Connected RaspberryPi can be used for a variety of purposes, such as displaying apps in kiosk mode, or running background services and providing processing power for services demanding apps.",
            'Android TV': "Connected Android Tv can be used for a variety of purposes, such as displaying apps in kiosk mode, or running background services and providing processing power for services demanding apps.",
            'Windows Computer': "Connected computer can be used for a variety of purposes, such as displaying apps in kiosk mode, or running background services and providing processing power for services demanding apps."
          }

        },
      },
      locations:{
        locationsGeneral: {
          type: 'Location Type',
          country: 'Country',
          city: 'City',
          address: 'Address',
          zipCode: 'Zip Code',
          geolocation: 'Geolocation',
          addedOn: 'Added On',
          uuid: 'UUID',
          onlineDevices: 'Has Online Devices',
          onlineAccounts: 'Has Online Accounts',
          locationDisplayId: 'Location Display Id',
          locationTimezone: 'Location Timezone',
          globalTimezone: 'UTC+1 (Space Timezone)'
        
        },
        locationDevices: {
          associated: 'Associated',
          connected: 'Connected',
          connectedDevices: 'Connected Devices',
          disconnected: 'Disconnected',
          disconnectedDevices: 'Disconnected Devices',
          nonConnected: 'Non-Connected',
          nonConnectedDevices: 'Non-Connected Devices',
          archived: 'Archived',
          archivedDevices: 'Archived Devices',
          installationPending: 'Installation Pending',
          latestAssociated: 'Latest Associated',
          structure: 'Structure',
          noDevices: 'No devices in this category',
          noAssociated: 'No devices associated with this Location yet.',
        },
        locationsInfoEdit: {
          title: 'General',
          locationName: 'Location Name',
          timezone: 'Timezone',
          tags: 'Tags',
          tagsSubtitle: 'Type a tag and press Enter, or select one from the list.'

        }
      },
      working_time: {
        headline: 'Working time',
        global: "Set global time for all locations",
        local: "Working time defined by global or local settings",
        button: {
          save: 'Save Changes',
          cancel: 'Discard',
          global: 'Global',
          local: 'Local'
        }
      },
      custom_fields: {
        headline: 'Working time',
        global: "Set global time for all locations",
        local: "Working time defined by global or local settings",
        button: {
          save: 'Save Changes',
          cancel: 'Discard',
          global: 'Global',
          local: 'Local',
        },
        radio: {
          required: 'Required',
          notRequired: 'None',
          requiredUnique: 'Required & Unique'
        },
        item: {
          notRequired: 'Not Required',
          required: 'Required',
          requiredUnique: 'Required & Unique'
        }
      },
      groups: {
        groupInfo:{
          tabs: {
            location: "Location",
          },
        },
        info: {
          created_at_label: "Created At",
          uuid_label: "UUID",
          number_of_group_locations: "Number Of Associated Locations"
        },
        emptyState: {
          title: "Location Groups",
          message: "List of all Location Groups will be shown here.",
          buttonText: "Create Location Group"
        },
        addGroup: {
          locationsLabel: "Locations",
          groupNameLabel: "Group Name",
          groupNamePlaceholder: "Friendly name for your location group",
          locationsPlaceholder: "Enter locations for your location group",
          locationListLabel: "Location list",
          devicesAndLocations: "devices and locations",
          activeLabel: "Active"
        }
      }
    },
    filterPanel: {
      clearFilters: "Clear Filters",
      devices: {
        locations: "Locations",
        categoriesAndTypes: "Device Categories & Types",
        connectedStatus: "Connected Status",
        activityStatus: "Activity status",
        deviceStatus: "Device Status",
        visionWorkers: "Vision Workers",
        visionOffline: "Vision Offline",
        tags: "Tags",
        totalResults: "Total Device Results",
      },
      locations: {
        locationType: "Location Type",
        country: "Country",
        tags: "Tags",
        totalResults: "Total Location Results",
      },
      accounts: {
        accountStatus: "Account Status",
        role: "Role",
        online: "Online",
        tags: "Tags",
        totalResults: "Total Account Results",
      },
      monitoring: {
        locations: "Locations",
        categoriesAndTypes: "Device Categories & Types",
        domain: "Domain",
        condition: "Condition",
        totalResults: "Total Device Results",
        cancelBtn: "Cancel",
        applyFilters: "Apply Filters",
      }
    }
  },

  hr: {
    sidebar: {
      assetsView: "Prostor",
      accountsView: "Korisnici"
    },
    profiles: {
      title: 'Profili',
      tabs: {
        adminTab: "Administratori",
        operatorsTab: "Operateri",
        operatorsGroupTab: "Grupe operatera"
      },
      operatorCredentials: {
        usernameLabel: 'Korisničko ime',
        passwordLabel: 'Lozinka',
        hints: {
          minLength: 'Min. dužina 8 znakova',
          includeNumber: 'Mora sadržavati barem jedan broj',
          includeUppercase: 'Mora sadržavati barem jedno veliko slovo',
          includeSpecial: 'Mora sadržavati barem jedan poseban znak',
        },
        rules: {
          required: 'Obavezno',
          minLength: 'Min dužina 5',
          includeNumber: 'Mora sadržavati broj',
          includeLowercase: 'Mora sadržavati malo slovo',
          includeUppercase: 'Mora sadržavati veliko slovo',
          includeSpecial: 'Mora sadržavati poseban znak',
          noBlankSpaces: 'Nisu dozvoljeni razmaci',
        },
      },
      operatorView: {
        loadError: {
          title: 'Neuspješno učitavanje operatera',
          retryBtn: 'Pokušaj ponovo',
        },
        loading: 'Učitavanje...',
        loadingOperator: 'Učitavanje operatera...',
        operatorFallback: 'Operater',
        operatorDetailsFallback: 'Detalji operatera',
        online: 'Online',
        offline: 'Offline',
        sections: {
          mainInfo: 'Osnovne informacije',
          additionalDetails: 'Dodatni detalji',
          customFields: 'Prilagođena polja',
        },
        fields: {
          firstName: 'Ime',
          dateOfBirth: 'Datum rođenja',
          email: 'E-mail',
          lastName: 'Prezime',
          gender: 'Pol',
          phoneNumber: 'Broj telefona',
          username: 'Korisničko ime',
          status: 'Status',
          visionId: 'Vision ID',
          tags: 'Oznake',
          operatorGroups: 'Grupe operatera',
          registeredAt: 'Registrovan',
          lastSeen: 'Posljednja aktivnost',
          uuid: 'UUID',
          locations: 'Lokacije',
          externalId: 'Eksterni ID',
          permissions: 'Dozvole',
          limits: 'Ograničenja',
          registeredBy: 'Registrovao',
          lastSeenAt: 'Posljednja lokacija',
          id: 'ID',
        },
        values: {
          enabled: 'Omogućeno',
          disabled: 'Onemogućeno',
          allPermissions: 'Sve dozvole',
          noLimits: 'Bez ograničenja',
        },
      },
    },
    assets: {
      title: "Prostor",
      tabs: {
        locationsTab: "Lokacije",
        devicesTab: "Uređaji"
      },
      display: {
        resolutionLabel: "Rezolucija",
        refreshRateLabel: "Osvježavanje",
        orientationLabel: "Orijentacija",
        displayedAppsLabel: "Prikazane aplikacije",
        searchPlaceholder: "Pretraga",
        primaryDisplayLabel: "Primarni ekran",
        disableDisplayLabel: "Onemogući ekran",
        streamDisplayLabel: "Stream ekran (LAN)",
        configureAppLabel: "Konfiguriraj aplikaciju"
      },
      devices: {
        searchPlaceholder: "Pretraga",
        emptyDevicesTitle: "Izgleda da nema dodanih uređaja",
        emptyDevicesDescription: "Da biste dodali uređaj, pređite mišem preko plusa na donjoj desnoj strani vašeg ekrana i odaberite željenu opciju.",
        emptySearchTitle: "Nema pronađenih uređaja",
        emptySearchDescription: "",
        fab: {
          addRunner: "Dodaj Runner uređaj",
          addManually: "Dodaj uređaj ručno",
          detect: "Detektiraj uređaje"
        },
        addRunner: {
          title: "Dodaj runner uređaj",
          description: "Nakon dodavanja uređaja, isti ćete moći povezati i upravljati njime.",
          addNew: "Dodaj novi",
          deviceNameLabel: "Naziv uređaja",
          deviceNamePlaceholder: "Naziv uređaja koji će se prikazivati",
          deviceDescriptionLabel: "Opis",
          deviceLocationLabel: "Lokacija",
          deviceLocationPlaceholder: "Pridružite Vaš uređaj nekoj lokaciji",
          addBtn: "Dodaj"
        },
        deviceInfo: {
          tabs: {
            general: "Generalno",
            peripherals: "Periferija",
            assetInfo: "Informacije",
            settings: "Postavke",
            devices: "Uređaji"
          },
          installationCode: {
            codeMessage: "Novi uređaj je dodan. Koristite sljedeći instalacijski kod da ga spojite preko Chameleon Runner-a:",
            codeExpiredMessage: "Instalacijski kod je istekao. Ako još uvijek želite spojiti ovaj uređaj, generirajte novi instalacijski kod kliknom na \"Resetiraj Kod\" dugme, u suprotnom ga možete obrisati da držite prostor čistim.",
            codeResetMessage: "Instalacijski kod je resetiran. Stari instalacijski kod neće više raditi. Koristite sljedeći instalacijski kod u naredna 24 sata da spojite uređaj preko Chameleon Runner-a:",
            codeEmailSentMessage: "Instalacijski kod je poslan na email ",
            codeEmailSentInfo: "Kada primatelj instalira uređaj preko instalacijskog koda, moći ćete upravljati uređajem. Ako trebate, uvijek možete poslani kod učiniti neispravnim tako što ćete ga resetirati.",
            expiresIn: "Ističe za: ",
            resetCodeBtn: "Resetiraj kod",
            codeInfoWhenUsed: "Nakon što je instalacijski kod uspješno iskorišten, uređaj će postati povezan. U međuvremenu, uvijek možete resetirati instalacijski kod ako je potrebno.",
            codeInfoSendEmail: "Ovaj instalacijski kod možete poslati na email. Primatelj će dobiti instalacijski kod, prilagođenu poruku i zadani set instrukcija kako iskoristiti instalacijski kod."
          },
          info: {
            deviceCategoryLabel: "Kategorija uređaja",
            deviceTypeLabel: "Tip uređaja",
            deviceClass: "Klasa uređaja",
            connectionStatusLabel: "Status veze",
            deviceStatusLabel: "Status uređaja",
            onlineStreakLabel: "Vrijeme rada",
            offlineStreakLabel: "Vrijeme neaktivnosti",
            locationLabel: "Lokacija",
            addedOnLabel: "Datum dodavanja",
            uuidLabel: "Unikatni identifikacijski ID (UUID)",
            actionsLabel: "Akcije",
            connectionStatusOnline: "Spojen",
            connectionStatusOffline: "Nije spojen",
            deviceStatusEnabled: "Omogućen",
            deviceStatusDisabled: "Onemogućen",
            installationDateLabel: "Datum instalacije",
            installationUuidLabel: "Instalacijski UUID",
            installationNameLabel: "Naziv instalacije",
            saltMinionIdLabel: "Salt Minion ID",
            lastUpdatedLabel: "Zadnje ažuriranje",
            nsDeskIdLabel: "NS Desk ID",
            machineID: "ID računara",
          },
          settings: {
            confTool: {
              title: "Pokreni konfigurator",
              description:
                "Pokrenite hardverski konfigurator na fizičkom uređaju za lokalno podešavanje.",
              button: "Pokreni konfigurator",
              confirm: {
                title: "Pokreni konfigurator",
                message: "Jeste li sigurni da želite pokrenuti konfigurator na fizičkom uređaju?",
                button: "Pokreni konfigurator",
              },
            },
            touchscreenCalibration: {
              title: "Pokreni kalibraciju",
              description:
                "Pokrenite kalibraciju dodirnog zaslona na fizičkom uređaju.",
              button: "Pokreni kalibraciju",
              confirm: {
                title: "Pokreni kalibraciju",
                message: "Jeste li sigurni da želite pokrenuti kalibraciju dodirnog zaslona na fizičkom uređaju?",
                button: "Pokreni kalibraciju",
              },
            },
          },
          typeDescriptions: {
            PC: "Spojeni računar se može koristiti u više svrha, kao što je prikaz aplikacija u kiosk načinu, ili pokretanju pozadinskih aplikacija i pružanju procesorske snage za potrebne aplikacije."
          }
        }
      }
    }
  }
};
export default messages